export { MapStatic as Static } from "./mapStatic";



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/components/map/map.tsx
// module id = R9i6
// module chunks = 2